import { ListManagerFrontendError } from '.';

export class InternalLogicError extends ListManagerFrontendError {
  static errorName = 'InternalLogicError';
}
